module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/kredito24-4b1d3df166a8a1c95692904f87af39c8.svg";